import React, { useState, useEffect } from 'react';
import {
    Modal, Form, Input, Button, Empty, Typography, Row, Col, Card, Divider, Tag, Tabs, Timeline, Statistic, DatePicker, message, Select, Checkbox, InputNumber,
    Switch,
    Tooltip,
    Descriptions,
} from 'antd';
import { MailOutlined, TeamOutlined, DownloadOutlined, CalendarOutlined, EditOutlined, CloseCircleOutlined, BankOutlined, EnvironmentOutlined, CreditCardOutlined, CheckCircleOutlined, PhoneOutlined, ArrowLeftOutlined, UserOutlined, MessageOutlined, SendOutlined, ClockCircleOutlined, TagOutlined, InfoCircleOutlined, CarOutlined, DollarOutlined, ShoppingOutlined, DoubleRightOutlined, UserSwitchOutlined, NodeIndexOutlined, CheckCircleFilled } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Avatar from 'react-avatar';
import moment from 'moment';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import API from '../../API/API';
import dayjs from "dayjs";
import { useNavigate } from 'react-router-dom';
import Config from '../../API/Config';
const { Text, Title, Paragraph } = Typography;
const { Option } = Select;
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { formatMoney } from '../../utils/money';
const leadStages = [
    "New",
    "Call Back",
    "Voice Mail",
    "Follow-Up",
    "Quoted",
    "Pending Payment",
    "Payment Completed",
    "Sales Made",
    "Part Not Available",
    "Wrong Number",
    "Not Interested",
    "Hang Up",
    "Fake",
    "Test Lead",
    "Negotiation",
];

const leadStageColors = {
    'New': { color: '#1890ff', background: '#e6f7ff' },
    'Call Back': { color: '#a0d911', background: '#fcffe6' },
    'Voice Mail': { color: '#2f54eb', background: '#f0f5ff' },
    'Follow-Up': { color: '#fa8c16', background: '#fff7e6' },
    'Quoted': { color: '#fadb14', background: '#feffe6' },
    'Sales Made': { color: '#fa8c16', background: '#fff7e6' },
    'Pending Payment': { color: '#237804', background: '#f6ffed' },
    'Payment Completed': { color: '#52c41a', background: '#f6ffed' },
    'Part Not Available': { color: '#237804', background: '#f6ffed' },
    'Wrong Number': { color: '#f5222d', background: '#fff1f0' },
    'Not Interested': { color: '#fa541c', background: '#fff2e8' },
    'Hang Up': { color: '#d48806', background: '#fffbe6' },
    'Fake': { color: '#d4b106', background: '#feffe6' },
    'Test Lead': { color: '#7cb305', background: '#fcffe6' },
    'Negotiation': { color: '#eb2f96', background: '#fff0f6' },
};

const stageTransitionRules = {
    "New": ["New", "Call Back", "Voice Mail", "Follow-Up", "Quoted", "Part Not Available", "Wrong Number", "Not Interested", "Hang Up", "Fake", "Test Lead"],
    "Call Back": ["Follow-Up", "Quoted", "Pending Payment", "Sales Made", "Part Not Available", "Wrong Number", "Not Interested", "Hang Up"],
    "Voice Mail": ["Call Back", "Follow-Up", "Quoted", "Pending Payment", "Sales Made", "Part Not Available", "Wrong Number", "Not Interested", "Hang Up"],
    "Follow-Up": ["Quoted", "Negotiation", "Pending Payment", "Sales Made", "Part Not Available", "Wrong Number", "Not Interested", "Hang Up"],
    "Quoted": ["Negotiation", "Pending Payment","Follow-Up", "Sales Made", "Part Not Available", "Not Interested"],
    "Negotiation": ["Pending Payment", "Sales Made", "Part Not Available", "Not Interested"],
    "Pending Payment": ["Payment Completed", "Quoted", "Sales Made"],
    "Payment Completed": ["Sales Made"],
    "Sales Made": [],
    "Part Not Available": [],
    "Wrong Number": [],
    "Not Interested": [],
    "Hang Up": [],
    "Fake": [],
    "Test Lead": []
};


const CommentItem = ({ comment }) => {
    const userInitials = comment.avatar || comment.author.substring(0, 2).toUpperCase();

    return (
        <div style={{
            padding: '16px',
            marginBottom: '16px',
            borderRadius: '8px',
            background: '#f9f9f9',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            borderLeft: '4px solid #1890ff'
        }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
                <Avatar
                    name={userInitials}
                    size="40"
                    round={true}
                    color="#1890ff"
                    textSizeRatio={2}
                />
                <div style={{ marginLeft: '12px', flexGrow: 1 }}>
                    <div style={{ fontWeight: 'bold', fontSize: '15px' }}>{comment.author}</div>
                    <div style={{ fontSize: '12px', color: '#888', display: 'flex', alignItems: 'center' }}>
                        <ClockCircleOutlined style={{ marginRight: '4px' }} />
                        {moment(comment.datetime).format('MM-DD-YYYY h:mm A')}
                    </div>
                </div>
            </div>
            <div className="comment-content"
                style={{
                    marginLeft: '52px',
                    lineHeight: '1.6',
                    fontSize: '14px'
                }}
                dangerouslySetInnerHTML={{ __html: comment.content }}
            />
        </div>
    );
};

const EmailTemplateModal = ({ visible, onCancel, onSend, lead, userData }) => {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSendEmail = async () => {
        setIsLoading(true);
        try {
            const textContent = body
                .replace(/<p>/g, '\n')
                .replace(/<br\s*\/?>/g, '\n')
                .replace(/&nbsp;/g, ' ')
                .replace(/<\/?[^>]+(>|$)/g, '');

            const emailData = {
                to: lead.personalInfo.email,
                subject: subject,
                text: textContent.trim(),
                html: `<html><body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 10px;">${body}</body></html>`,
                agentId: userData?.id,
            };

            const response = await axios.post(`${Config.baseURL}/api/send-email`, emailData);
            if (response.status) {
                message.success('Email sent successfully!');
                onCancel();
            }
        } catch (error) {
            console.error('Failed to send email:', error);
            message.error('Failed to send email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link'
    ];

    useEffect(() => {
        if (visible && lead) {
            // Current price: the newest quotedValue entry, which matches totalAmount.
            const latestPrice = lead.quotedValue?.[lead.quotedValue.length - 1]?.price || lead.totalAmount;
            const defaultBody = `
                <p>Dear ${lead.personalInfo.fullName},</p>
                <p>I hope this message finds you well. I wanted to follow up on your recent inquiry about the <strong>${lead.vehicleInfo.part}</strong> for your <strong>${lead.vehicleInfo.year} ${lead.vehicleInfo.make} ${lead.vehicleInfo.model}</strong>.</p>
                <p>Here's a quick recap of the details we discussed:</p>
                <ul>
                    <li><strong>Part:</strong> ${lead.vehicleInfo.part}</li>
                    <li><strong>Vehicle:</strong> ${lead.vehicleInfo.year} ${lead.vehicleInfo.make} ${lead.vehicleInfo.model}</li>
                    <li><strong>Price:</strong> ${latestPrice ? formatMoney(latestPrice) : 'N/A'}</li>
                </ul>
                <p>Best regards,</p>
                <p><strong>${userData?.firstName} ${userData?.lastName}</strong></p>
            `;
            setBody(defaultBody);
            setSubject(`Follow-Up on Your Recent Inquiry About ${lead.vehicleInfo.part}`);
        }
    }, [visible, lead, userData]);

    return (
        <Modal
            title="Send Follow-Up Email"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>Cancel</Button>,
                <Button key="send" type="primary" onClick={handleSendEmail} loading={isLoading}>
                    Send Email
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item label="To">
                    <Input value={lead?.personalInfo?.email || ''} />
                </Form.Item>
                <Form.Item label="Subject" rules={[{ required: true, message: 'Please enter a subject' }]}>
                    <Input placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                </Form.Item>
                <Form.Item label="Body" rules={[{ required: true, message: 'Please enter the email body' }]}>
                    <ReactQuill
                        value={body}
                        onChange={setBody}
                        modules={modules}
                        formats={formats}
                        placeholder="Compose your email..."
                        style={{ height: '200px', marginBottom: '40px', borderRadius: '8px' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

// Lead stage card component remains the same
const LeadStageCard = ({ leadStage, leadStages, stageColorMap, handleStageChange }) => {
    const [newLeadStage, setNewLeadStage] = useState(leadStage);
    const [comment, setComment] = useState("");
    const [followUpDate, setFollowUpDate] = useState(null);
    const [quotePrices, setQuotePrices] = useState([""]);
    const [shippingAddress, setShippingAddress] = useState({
        street: "",
        city: "",
        state: "",
        zip: "",
    });
    const [billingAddress, setBillingAddress] = useState({
        street: "",
        city: "",
        state: "",
        zip: "",
    });
    const [isSameAddress, setIsSameAddress] = useState(false);
    const [bussinessName, setBusinessName] = useState("");
    const [paymentPending, setPaymentPending] = useState([{ amount: "", advancePayment: "", description: "" }]);
    const [isEditing, setIsEditing] = useState(false);

    // Reset the form when leadStage changes
    useEffect(() => {
        setNewLeadStage(leadStage);
        setComment("");
        setFollowUpDate(null);
        setQuotePrices([""]);
        setShippingAddress({
            street: "",
            city: "",
            state: "",
            zip: "",
        });
        setBillingAddress({
            street: "",
            city: "",
            state: "",
            zip: "",
        });
        setBusinessName("");
        setPaymentPending([{ amount: "", advancePayment: "", description: "" }]);

    }, [leadStage]);

    const handleStageSelect = (value) => {
        setNewLeadStage(value);
        if (value !== "Follow-Up") {
            setFollowUpDate(null);
        }
    };


    const handlePendingChange = (index, field, value) => {
        const updatedPaymentPending = [...paymentPending];

        // If updating amount, ensure advancePayment is not more than amount
        if (field === "amount" && updatedPaymentPending[index].advancePayment > value) {
            message.error("Advance payment cannot exceed the total amount.");
            updatedPaymentPending[index].advancePayment = value; // Adjust advance payment if needed
        }

        updatedPaymentPending[index][field] = value;
        setPaymentPending(updatedPaymentPending);
    };
    const handleAdvancePaymentChange = (index, value) => {
        const updatedPaymentPending = [...paymentPending];
        const amount = Number(updatedPaymentPending[index].amount) || 0;

        if (value > amount) {
            message.error("Advance payment cannot exceed the total amount.");
            return;
        }

        updatedPaymentPending[index].advancePayment = value;
        setPaymentPending(updatedPaymentPending);
    };


    const handleQuotePriceChange = (index, value) => {
        const updatedPrices = [...quotePrices];
        updatedPrices[index] = value;
        setQuotePrices(updatedPrices);
    };
    const addQuotePriceField = () => {
        setQuotePrices([...quotePrices, ""]); // Add new empty price field
    };

    const removeQuotePriceField = (index) => {
        const updatedPrices = quotePrices.filter((_, i) => i !== index);
        setQuotePrices(updatedPrices);
    };
    const handleAddressChange = (type, field, value) => {
        if (type === "shipping") {
            const updatedShipping = { ...shippingAddress, [field]: value };
            setShippingAddress(updatedShipping);

            if (isSameAddress) {
                setBillingAddress(updatedShipping);
            }
        } else {
            setBillingAddress((prev) => ({ ...prev, [field]: value }));
        }
    };
    const handleSameAddressToggle = (checked) => {
        setIsSameAddress(checked);
        if (checked) {
            setBillingAddress(shippingAddress);
        } else {
            setBillingAddress({
                street: "",
                city: "",
                state: "",
                zip: "",
            });
        }
    };
    const handleCommentSubmit = async () => {
        // if(){}
        const additionalData = { comment };

        if (newLeadStage === "Follow-Up" && followUpDate) {
            additionalData.followUpDate = followUpDate.toISOString();
        }
        if (newLeadStage === "Quoted") {
            additionalData.quotedValue = quotePrices
                .filter((price) => price) // Remove empty entries
                .map((price) => ({ price }));
        }
        if (newLeadStage === "Sales Made") {
            additionalData.bussinessName = bussinessName;
            additionalData.shippingAddress = shippingAddress;
            additionalData.billingAddress = billingAddress;
        }
        if (newLeadStage === "Pending Payment") {
            additionalData.quotes = paymentPending
                .filter(q => q.amount) // Only include if amount is provided
                .map(q => ({
                    amount: Number(q.amount),
                    advancePayment: Number(q.advancePayment || 0),
                    description: q.description || ""
                }));
        }

        else {
            additionalData.comment = comment;
        }

        try {
            await handleStageChange(newLeadStage, additionalData);
            setComment("");
            setFollowUpDate(null);
            setQuotePrices([""]);
            setShippingAddress({
                street: "",
                city: "",
                state: "",
                zip: "",
            });
            setBillingAddress({
                street: "",
                city: "",
                state: "",
                zip: "",

            });
            setIsSameAddress(false);
            setPaymentPending([{ amount: "", advancePayment: "", description: "" }]);
            setIsEditing(false);

        } catch (error) {
            console.error("Error updating lead stage:", error);
        }
    };
    const userData = JSON.parse(localStorage.getItem("userData"));

    return (
        <Card
            title={
                <span>
                    <TagOutlined /> Lead Stage
                </span>
            }
            extra={
                <Button
                    type={isEditing ? "default" : "primary"}
                    onClick={() => {
                        if (isEditing) {
                            // Reset all fields to original leadStage state
                            setNewLeadStage(leadStage);
                            setComment("");
                            setFollowUpDate(null);
                            setQuotePrices([""]);
                            setShippingAddress({
                                street: "",
                                city: "",
                                state: "",
                                zip: "",
                            });
                            setBillingAddress({
                                street: "",
                                city: "",
                                state: "",
                                zip: "",
                            });
                            setBusinessName("");
                            setPaymentPending([{ amount: "", advancePayment: "", description: "" }]);
                            setIsSameAddress(false);
                        }
                        setIsEditing(!isEditing);
                    }}
                    disabled={userData.role === "ADMIN"}
                >
                    {isEditing ? <CloseCircleOutlined /> : <EditOutlined />
                    }
                </Button>

            }
            style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.09)" }}
        >

            {isEditing ? (
                <>

                    <Select
                        value={newLeadStage}
                        onChange={handleStageSelect}
                        style={{ width: "100%", marginTop: 16 }}
                        size="large"
                        placeholder="Select Next Stage"
                        disabled={leadStage === "Sales Made"}
                    >
                        {stageTransitionRules[leadStage]?.map((stage) => (
                            <Option key={stage} value={stage}>
                                <Tag >{stage}</Tag>
                            </Option>
                        ))}
                    </Select>

                    {newLeadStage === "Follow-Up" && (
                        <DatePicker
                            value={followUpDate ? dayjs(followUpDate) : null}
                            onChange={(date) => setFollowUpDate(date)}
                            format="MM/DD/YYYY hh:mm A"
                            style={{ width: "100%", marginTop: "16px" }}
                            showTime={{
                                format: "hh:mm A",
                                use12Hours: true,
                                hourStep: 1,
                                minuteStep: 1,
                                showNow: true,
                            }}
                            disabledDate={(current) => {
                                return current && current < dayjs().startOf('day');
                            }}
                            disabledTime={(current) => {
                                if (!current) return {};
                                const now = dayjs();
                                if (current.isSame(now, 'day')) {
                                    const disabledHours = [];
                                    for (let i = 0; i < 24; i++) {
                                        if (i < now.hour()) disabledHours.push(i);
                                    }
                                    const disabledMinutes = [];
                                    if (current.hour() === now.hour()) {
                                        for (let i = 0; i < now.minute(); i++) {
                                            disabledMinutes.push(i);
                                        }
                                    }
                                    return {
                                        disabledHours: () => disabledHours,
                                        disabledMinutes: () => disabledMinutes,
                                    };
                                }
                                return {};
                            }}
                            popupClassName="custom-datepicker-popup"
                        />
                    )}

                    {newLeadStage === "Quoted" && (
                        <>
                            {quotePrices.map((price, index) => (
                                <div key={index} style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                                    <InputNumber
                                        value={price}
                                        onChange={(value) => handleQuotePriceChange(index, value)}
                                        placeholder={`Enter quoted price ${index + 1}`}
                                        min={0}
                                        style={{ width: "100%" }}
                                        prefix="$"
                                    />

                                </div>
                            ))}

                        </>
                    )}
                    {newLeadStage === "Pending Payment" && (
                        <>
                            {paymentPending.map((quote, index) => (
                                <div key={index} style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                                    <InputNumber
                                        value={quote.amount}
                                        onChange={(value) => handlePendingChange(index, "amount", value)}
                                        placeholder="Amount"
                                        min={0}
                                        style={{ width: "30%" }}
                                        prefix="$"
                                    />
                                    <InputNumber
                                        value={quote.advancePayment}
                                        onChange={(value) => handleAdvancePaymentChange(index, value)}
                                        placeholder="Advance Payment"
                                        min={0}
                                        style={{ width: "30%" }}
                                        prefix="$"
                                    />

                                </div>
                            ))}
                        </>
                    )}
                    {newLeadStage === "Sales Made" && (
                        <>
                            <h3 style={{ marginTop: 16 }}>Business Name</h3>
                            <Input
                                placeholder="Enter Business Name"
                                value={bussinessName}
                                label="Business Name"
                                onChange={(e) => setBusinessName(e.target.value)}
                                style={{ marginTop: 8 }}
                            />
                            <h3 style={{ marginTop: 16 }}>Shipping Address</h3>
                            <Input placeholder="Street" value={shippingAddress.street} onChange={(e) => handleAddressChange("shipping", "street", e.target.value)} style={{ marginTop: 8 }} />
                            <Input placeholder="City" value={shippingAddress.city} onChange={(e) => handleAddressChange("shipping", "city", e.target.value)} style={{ marginTop: 8 }} />
                            <Input placeholder="State" value={shippingAddress.state} onChange={(e) => handleAddressChange("shipping", "state", e.target.value)} style={{ marginTop: 8 }} />
                            <Input type="Number" placeholder="ZIP Code" value={shippingAddress.zip} onChange={(e) => handleAddressChange("shipping", "zip", e.target.value)} style={{ marginTop: 8 }} />

                            <Checkbox style={{ marginTop: 16 }} checked={isSameAddress} onChange={(e) => handleSameAddressToggle(e.target.checked)}>
                                Copy shipping address to billing address
                            </Checkbox>

                            <h3 style={{ marginTop: 16 }}>Billing Address</h3>
                            <Input placeholder="Street" value={billingAddress.street} onChange={(e) => handleAddressChange("billing", "street", e.target.value)} style={{ marginTop: 8 }} disabled={isSameAddress} />
                            <Input placeholder="City" value={billingAddress.city} onChange={(e) => handleAddressChange("billing", "city", e.target.value)} style={{ marginTop: 8 }} disabled={isSameAddress} />
                            <Input placeholder="State" value={billingAddress.state} onChange={(e) => handleAddressChange("billing", "state", e.target.value)} style={{ marginTop: 8 }} disabled={isSameAddress} />
                            <Input type="Number" placeholder="ZIP Code" value={billingAddress.zip} onChange={(e) => handleAddressChange("billing", "zip", e.target.value)} style={{ marginTop: 8 }} disabled={isSameAddress} />
                        </>
                    )}

                    {newLeadStage !== "Sales Made" && (
                        <Input.TextArea
                            rows={4}
                            placeholder="Enter a comment about the stage change..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            style={{ marginTop: 16 }}
                        />
                    )}
                    <Button
                        type="primary"
                        onClick={handleCommentSubmit}
                        style={{ marginTop: 16 }}
                        disabled={
                            (newLeadStage !== "Sales Made" && !comment.trim()) ||
                            (newLeadStage === "Follow-Up" && !followUpDate)
                        }
                    >
                        Update Stage with Comment
                    </Button>
                </>
            ) : (
                <div style={{ marginTop: 16 }}>
                    <p><strong>Current Stage:</strong> {leadStage}</p>


                </div>
            )}
        </Card>
    );
};
const EnhancedAPI = {
    ...API,


    RecordNewPayment: async (id, paymentData) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/payments`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(paymentData),
            });
            return await response.json();
        } catch (error) {
            throw new Error('Failed to record payment');
        }
    }
};
const FormItem = ({ label, children, error }) => {
    return (
        <div style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: '8px', fontSize: '14px' }}>{label}</div>
            {children}
            {error && <div style={{ color: '#f5222d', fontSize: '12px', marginTop: '4px' }}>{error}</div>}
        </div>
    );
};
const PaymentHistoryModal = ({ visible, onCancel, payments, quotes }) => {

    return (
        <Modal
            title="Payment History"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="close" onClick={onCancel}>
                    Close
                </Button>
            ]}
            width={800}
        >
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Payment Details" key="1">

                    {/* Payment History Section */}
                    <Card
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>Payment History</span>
                                <Text strong>Total Paid: ${quotes[0]?.amount?.toFixed(2)}</Text>
                            </div>
                        }
                        style={{ marginBottom: 24 }}
                    >
                        {payments && payments.length > 0 ? (
                            <Timeline mode="left">
                                {[...payments]
                                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                                    .map((payment, index) => (
                                        <Timeline.Item
                                            key={index}
                                            color={payment.status === 'Completed' ? 'green' : 'orange'}
                                        >
                                            <Card size="small">
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Text strong>
                                                        {new Date(payment.date).toLocaleDateString('en-US', {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            year: 'numeric'
                                                        })} – ${payment.amount.toFixed(2)}
                                                    </Text>

                                                </div>
                                                <div style={{ marginTop: '8px' }}>
                                                    <Text>Method: {payment.paymentMethod}</Text>
                                                </div>
                                                {payment.description && (
                                                    <div style={{ marginTop: '8px' }}>
                                                        <Text>Note: {payment.description}</Text>
                                                    </div>
                                                )}
                                            </Card>
                                        </Timeline.Item>
                                    ))}
                            </Timeline>
                        ) : (
                            <Empty description="No payments available" />
                        )}
                    </Card>

                    {/* First Payment Section */}
                    <Card title="First Payment">
                        {quotes && quotes.length > 0 ? (
                            quotes.map((quote, index) => (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '16px',
                                        padding: '16px',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                        <Text strong>
                                            Advance Payment: ${quote.advancePayment.toFixed(2)}
                                        </Text>

                                    </div>
                                    <Text type="secondary">
                                        Description: {quote.description || 'No description provided'}
                                    </Text>
                                </div>
                            ))
                        ) : (
                            <Empty description="No quotes available" />
                        )}
                    </Card>
                </Tabs.TabPane>
            </Tabs>
        </Modal>
    );
};



// Main component with lead fetching logic
const IndividualFollowUpLead = () => {
    const { id } = useParams(); // Get ID from URL
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [leadComments, setLeadComments] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
    const [stage, setStage] = useState('New');
    const navigate = useNavigate();
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [paymentForm, setPaymentForm] = useState({
        amount: '',
        paymentMethod: 'Credit Card',
        description: ''
    });
    const [paymentFormErrors, setPaymentFormErrors] = useState({
        amount: '',
    });
    const [paymentHistoryModalVisible, setPaymentHistoryModalVisible] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [newQuotePrice, setNewQuotePrice] = useState(null);
    const handlePaymentFormChange = (field) => (e) => {
        setPaymentForm({
            ...paymentForm,
            [field]: field === 'amount'
                ? (e.target.value === '' ? '' : parseFloat(e.target.value))
                : e.target.value
        });
    };

    const handleRecordPayment = async () => {
        try {
            const response = await EnhancedAPI.RecordNewPayment(id, paymentForm);

            if (response.status) {
                // Calculate new values
                const newPayment = {
                    amount: parseFloat(paymentForm.amount) || 0,
                    paymentMethod: paymentForm.paymentMethod,
                    description: paymentForm.description,
                    date: new Date().toISOString()
                };

                // Update lead state
                setLead(prevLead => {
                    const newAdvancePayments = [...(prevLead.advancePayments || []), newPayment];
                    const totalPaid = newAdvancePayments.reduce((sum, p) => sum + p.amount, 0);
                    const totalQuoted = prevLead.quotes.reduce((sum, q) => sum + q.amount, 0);
                    const newBalance = totalQuoted - totalPaid;
                    const shouldCompletePayment = newBalance <= 0;

                    return {
                        ...prevLead,
                        advancePayments: newAdvancePayments,
                        paidAmount: totalPaid,
                        balanceAmount: newBalance,
                        leadStage: shouldCompletePayment ? "Payment Completed" : prevLead.leadStage,
                        // paymentStatus: shouldCompletePayment ? "Completed" : "Pending"
                    };
                });

                // Close modal and reset form
                setPaymentModalVisible(false);
                setPaymentForm({ amount: '', paymentMethod: 'Credit Card', description: '' });

                message.success('Payment recorded successfully!');

                // If balance is 0, update the stage immediately
                const updatedLead = await API.GetLeadById(id);
                if (updatedLead?.status) {
                    setLead(updatedLead.data);
                }
            } else {
                message.error(response.message || "Failed to record payment");
            }
        } catch (error) {
            message.error(error.message || "Error recording payment");
        }
    };

    // Fetch lead data when component mounts
    useEffect(() => {
        const fetchLead = async () => {
            try {
                const response = await API.GetLeadById(id);

                if (response.status) {
                    setLead(response.data);
                    setStage(response.data.leadStage);
                } else {
                    setError('Failed to fetch lead data');
                }
            } catch (err) {
                setError('Error fetching lead data');
                console.error('Error fetching lead:', err);
            } finally {
                setLoading(false);
            }
        };

        // Get user data from localStorage
        const storedUserData = localStorage.getItem('userData')
            ? JSON.parse(localStorage.getItem('userData'))
            : null;
        setUserData(storedUserData);

        fetchLead();
    }, [id]);

    // Fetch comments when lead is loaded
    useEffect(() => {
        const fetchComments = async () => {
            if (!lead?._id) return;

            try {
                const response = await axios.get(`${Config.baseURL}/api/comments/${lead._id}`);
                setLeadComments(response.data);
            } catch (err) {
                console.error('Error fetching comments:', err);
            }
        };

        fetchComments();
    }, [lead]);

    // Handle stage change
    const handleStageChange = async (newLeadStage, additionalData = {}) => {
        const previousLeadStage = lead.leadStage;
        const previousLead = { ...lead };

        try {
            let payload = { leadStage: newLeadStage };

            if (newLeadStage === "Quoted") {
                if (!additionalData.quotedValue) {
                    message.error("At least one quote is required when changing stage to Quoted.");
                    return;
                }
                if (!additionalData.comment) {
                    message.error("A comment is required when changing stage to Quoted.");
                    return;
                }
                payload = {
                    ...payload,
                    quotedValue: additionalData.quotedValue.map(quote => ({ price: quote.price })),
                    comment: additionalData.comment,
                };
            } else if (newLeadStage === "Follow-Up") {
                if (!additionalData.followUpDate) {
                    message.error("Follow-Up date is required when changing stage to Follow-Up.");
                    return;
                }
                payload = {
                    ...payload,
                    comment: additionalData.comment,
                    followUpDate: additionalData.followUpDate,
                };
            } else if (newLeadStage === "Sales Made") {
                const { shippingAddress, billingAddress, bussinessName } = additionalData;
                if (!shippingAddress?.street || !shippingAddress?.city || !shippingAddress?.state || !shippingAddress?.zip) {
                    message.error("Complete shipping address is required when changing stage to Sales Made.");
                    return;
                }
                if (!billingAddress?.street || !billingAddress?.city || !billingAddress?.state || !billingAddress?.zip) {
                    message.error("Complete billing address is required when changing stage to Sales Made.");
                    return;
                }
                if (!bussinessName?.trim()) {
                    message.error("Business Name is required when changing stage to Sales Made.");
                    return;
                }
                payload = {
                    ...payload,
                    shippingAddress,
                    billingAddress,
                    bussinessName
                };
            } else if (newLeadStage === "Pending Payment") {
                if (!additionalData.quotes || additionalData.quotes.length === 0) {
                    message.error("At least one quote is required when changing stage to Pending Payment.");
                    return;
                }

                // Calculate totals from the quotes
                const totalAmount = additionalData.quotes.reduce((sum, q) => sum + q.amount, 0);
                const totalAdvance = additionalData.quotes.reduce((sum, q) => sum + q.advancePayment, 0);
                const balance = totalAmount - totalAdvance;

                payload = {
                    ...payload,
                    quotes: additionalData.quotes,
                    totalAmount,
                    paidAmount: totalAdvance,
                    balanceAmount: balance,
                    comment: additionalData.comment || "",
                };
            }


            else if (additionalData.comment) {
                payload.comment = additionalData.comment;
            }
            const response = await API.UpdateLead(lead._id, payload);

            if (response?.status) {
                setStage(newLeadStage);
                setLead(prev => ({
                    ...prev,
                    ...payload, // Spread all the updated fields
                    leadStage: newLeadStage,
                    leadStageHistory: [
                        ...(prev.leadStageHistory || []),
                        {
                            stage: newLeadStage,
                            changedAt: new Date().toISOString(),
                            changedBy: userData?.id || "Unknown",
                            comment: additionalData.comment || ""
                        }
                    ],
                    ...(newLeadStage === "Quoted" && {
                        quotedValue: [...(prev.quotedValue || []), ...additionalData.quotedValue.map(q => ({ price: q.price, addedAt: new Date() }))]
                    })
                }));
                message.success(`Lead stage updated to ${newLeadStage} successfully`);
            } else {
                setStage(previousLeadStage);
                setLead(previousLead);
                message.error(response?.message || 'Failed to update lead stage');
            }
        } catch (error) {
            console.error('Error updating lead stage:', error);
            setStage(previousLeadStage);
            setLead(previousLead);
            message.error('Failed to update lead stage');
        }
    };

    // Handle comment submission
    const handleCommentSubmit = async () => {
        if (!commentText.trim()) return;

        setIsSubmitting(true);

        try {
            const userInitials = userData
                ? `${userData.firstName[0]}${userData.lastName[0]}`
                : 'UN';

            const newComment = {
                leadId: lead._id,
                author: userData ? `${userData.firstName} ${userData.lastName}` : 'Unknown User',
                content: commentText,
                avatar: userInitials,
            };

            const response = await axios.post(`${Config.baseURL}/api/comments`, newComment);
            setLeadComments([response.data, ...leadComments]);
            setCommentText('');
        } catch (error) {
            console.error('Error posting comment:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handle email sending
    const handleSendEmail = async (emailData) => {
        try {
            const response = await axios.post(`${Config.baseURL}/api/send-email`, emailData);
            if (response.data.success) {
                console.log('Email sent successfully:', response.data.messageId);
            }
        } catch (error) {
            console.error('Failed to send email:', error);
        }
    };

    // Quill editor configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link'
    ];

    // Get current stage color
    const getCurrentStageColor = () => {
        if (!lead) return { color: '#000', background: '#f0f0f0' };

        const currentStage = lead.leadStageHistory?.length > 0
            ? lead.leadStageHistory[lead.leadStageHistory.length - 1].stage
            : lead.leadStage || 'New';

        return leadStageColors[currentStage] || { color: '#000', background: '#f0f0f0' };
    };

    const stageStyle = getCurrentStageColor();

    if (loading) {
        return <div style={{ padding: '24px', textAlign: 'center' }}>Loading lead data...</div>;
    }

    if (error) {
        return <div style={{ padding: '24px', textAlign: 'center', color: 'red' }}>Error: {error}</div>;
    }

    if (!lead) {
        return <div style={{ padding: '24px', textAlign: 'center' }}>No lead data found</div>;
    }

    // Prepare stage history for timeline
    const stageHistory = lead.leadStageHistory?.length > 0
        ? lead.leadStageHistory.map(item => ({
            stage: item.stage,
            date: item.changedAt,
            comment: item.comment
        }))
        : [{ stage: lead.leadStage, date: lead.createdAt }];
    const getAdvancePaymentTotal = () => {
        const paymentsFromAdvancePayments = lead?.advancePayments?.reduce(
            (total, payment) => total + (parseFloat(payment.amount) || 0), 0) || 0;
        const paymentsFromQuotes = lead?.quotes?.reduce(
            (total, quote) => total + (parseFloat(quote.advancePayment) || 0), 0) || 0;
        return paymentsFromAdvancePayments + paymentsFromQuotes;
    };

    const getQuoteTotal = () => {
        return lead?.quotes?.reduce((total, quote) => total + quote.amount, 0) || 0;
    };

    const getRemainingBalance = () => {
        return getQuoteTotal() - getAdvancePaymentTotal();
    };

    // Then use these
    const totalPrice = getQuoteTotal();
    const advancePrice = getAdvancePaymentTotal();
    const balancePrice = getRemainingBalance();

    const validatePaymentAmount = (value) => {
        const totalPrice = getQuoteTotal();
        const advancePrice = getAdvancePaymentTotal();
        const remainingBalance = totalPrice - advancePrice;

        if (value > remainingBalance) {
            setPaymentFormErrors({
                ...paymentFormErrors,
                amount: `Amount cannot exceed remaining balance of $${remainingBalance.toFixed(2)}`
            });
            return false;
        } else {
            setPaymentFormErrors({
                ...paymentFormErrors,
                amount: ''
            });
            return true;
        }
    };
    const handlePaymentAmountChange = (value) => {
        validatePaymentAmount(value);
        setPaymentForm({
            ...paymentForm,
            amount: value
        });
    };
    const generatePaymentPDF = () => {
        // Create a temporary div to render the PDF content
        const pdfContent = document.createElement('div');
        pdfContent.style.position = 'absolute';
        pdfContent.style.left = '-9999px';
        pdfContent.style.width = '600px';
        pdfContent.style.padding = '20px';
        pdfContent.style.backgroundColor = 'white';

        // Format the content to match your screenshot
        pdfContent.innerHTML = `
          <div style="font-family: Arial, sans-serif; color: #333;">
            <h1 style="color: #4169E1; border-bottom: 1px solid #eee; padding-bottom: 10px;">
              Payment Receipt
            </h1>
            
            <div style="text-align: center; margin: 20px 0;">
              <h2 style="color: #4169E1;">$${lead.quotes[0].amount.toFixed(2)}</h2>
              <p style="font-size: 18px; color: #22c55e;">
                <CheckCircleOutlined /> Payment Completed
              </p>
            </div>
            
        <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0;">
  <h3 style="border-bottom: 1px solid #ddd; padding-bottom: 8px;">Payment Information</h3>
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
    <div><strong>Payment Method:</strong></div>
    <div>${lead.advancePayments?.[lead.advancePayments.length - 1]?.paymentMethod || 'N/A'}</div>

    <div><strong>Payment Status:</strong></div>
    <div>${lead.paymentStatus}</div>

    <div><strong>Transaction ID:</strong></div>
    <div>${lead.advancePayments?.[lead.advancePayments.length - 1]?.id || 'N/A'}</div>

    <div><strong>Date:</strong></div>
    <div>${new Date(lead.advancePayments?.[lead.advancePayments.length - 1]?.date || new Date()).toLocaleString()}</div>
  </div>
</div>

            
            <div style="margin-top: 20px; font-size: 12px; color: #666; text-align: center;">
              Thank you for your payment!
            </div>
          </div>
        `;

        document.body.appendChild(pdfContent);

        // Generate PDF
        html2canvas(pdfContent).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210; // A4 width in mm
            const imgHeight = canvas.height * imgWidth / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`payment-receipt-${lead._id}.pdf`);

            // Clean up
            document.body.removeChild(pdfContent);
        });
    };
    const formatDateToPST = (isoString) => {
        if (typeof isoString !== 'string' || !isoString.trim()) {
            console.warn("Empty or invalid ISO string:", isoString);
            return 'Invalid Date';
        }

        const date = new Date(isoString);
        if (isNaN(date.getTime())) {
            console.warn("Invalid date value:", isoString);
            return 'Invalid Date';
        }

        return new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Los_Angeles',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        }).format(date);
    };

    const handleSecondaryStatusChange = async (checked) => {
        try {
            const newStatus = checked ? 'Yes' : 'No';
            const response = await API.UpdateLead(id, { secondaryStatus: newStatus });

            if (response?.status) {
                setLead(prev => ({
                    ...prev,
                    secondaryStatus: newStatus
                }));
                message.success(`Secondary status updated to ${newStatus}`);
            } else {
                message.error(response?.message || 'Failed to update secondary status');
            }
        } catch (error) {
            console.error('Error updating secondary status:', error);
            message.error('Failed to update secondary status');
        }
    };
    const handleUpdateQuote = async (newPrice) => {
        try {
            if (!newPrice) {
                message.error("Please enter a valid quote amount");
                return;
            }

            // Only the new quote is sent; the server appends it to the full
            // quote history and records who added it.
            const payload = {
                quotedValue: [{ price: newPrice }]
            };

            // Call the API to update the lead
            const response = await API.UpdateLead(id, payload);

            if (response?.status) {
                // Update the local state with the new data
                setLead(response.data);
                message.success('New quote added successfully!');
                setNewQuotePrice(null);
            } else {
                message.error(response?.message || 'Failed to add new quote');
            }
        } catch (error) {
            console.error('Error adding new quote:', error);
            message.error('Failed to add new quote');
        }
    };
    return (
        <div style={{ padding: '24px' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                {/* Left side: Back button and lead type */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        type="link"
                        onClick={() => navigate("/my-follow-ups")}
                        style={{ fontSize: '16px', padding: 0 }}
                    >
                        <ArrowLeftOutlined /> Back
                    </Button>
                    <span style={{ margin: '0 10px' }}>/</span>
                    <strong style={{ fontSize: '18px' }}>{lead.leadType}</strong>
                </div>

                {/* Right side: Switch for SALES-AGENT */}
                <div>
                    <Tooltip title="Transfer the lead">
                        <Button
                            type="primary"
                            ghost
                            icon={<DoubleRightOutlined />}
                            className="transfer-btn"
                            onClick={async () => {
                                // Fetch agents first
                                let agents = [];
                                try {
                                    const response = await API.userGetAll();
                                    if (response?.success) {
                                        // Filter only SALES-AGENTs and map to options format
                                        agents = response.data
                                            .filter(user => user.role === "SALES-AGENT" && user.subRole !== "TIER-3")
                                            .map(user => ({
                                                value: user._id,
                                                label: `${user.firstName} ${user.lastName}`,
                                                user // Store full user object for reference
                                            }));
                                    }
                                } catch (error) {
                                    console.error('Failed to fetch agents:', error);
                                    message.error('Failed to load agents');
                                    return;
                                }

                                let transferType = null;
                                let selectedAgent = null;

                                // Step 1: Ask for transfer type
                                Modal.confirm({
                                    title: 'Transfer Lead',
                                    icon: <DoubleRightOutlined className="modal-icon" />,
                                    width: 450,
                                    className: "transfer-modal",
                                    content: (
                                        <div className="transfer-type-selection">
                                            <p>Please select the type of transfer:</p>
                                            <Select
                                                style={{ width: '100%', marginTop: 16 }}
                                                placeholder="Select transfer type"
                                                size="large"
                                                onChange={(value) => transferType = value}
                                            >
                                                <Option value="primary">
                                                    <span className="option-label">
                                                        <UserSwitchOutlined /> Primary Transfer
                                                    </span>
                                                </Option>
                                                <Option value="secondary">
                                                    <span className="option-label">
                                                        <NodeIndexOutlined /> Secondary Transfer
                                                    </span>
                                                </Option>
                                            </Select>
                                        </div>
                                    ),
                                    onOk: async () => {
                                        if (!transferType) {
                                            message.error('Please select a transfer type');
                                            return Promise.reject();
                                        }

                                        if (transferType === 'secondary') {
                                            // Handle secondary transfer
                                            handleSecondaryStatusChange(true);
                                            message.success({
                                                content: 'Lead marked as secondary',
                                                icon: <CheckCircleFilled style={{ color: '#52c41a' }} />
                                            });
                                            return;
                                        }

                                        // For primary transfer, show agent selection
                                        return new Promise((resolve) => {
                                            Modal.confirm({
                                                title: 'Select Agent for Transfer',
                                                icon: <UserSwitchOutlined className="modal-icon" />,
                                                width: 450,
                                                className: "agent-select-modal",
                                                content: (
                                                    <div className="agent-selection">
                                                        <p>Select the agent who will handle this lead:</p>
                                                        <Select
                                                            style={{ width: '100%', marginTop: 16 }}
                                                            placeholder="Search for an agent"
                                                            size="large"
                                                            showSearch
                                                            filterOption={(input, option) =>
                                                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            options={agents}
                                                            onChange={(value) => {
                                                                selectedAgent = agents.find(a => a.value === value)?.user;
                                                            }}
                                                        />
                                                    </div>
                                                ),
                                                onOk: async () => {
                                                    if (!selectedAgent) {
                                                        message.error('Please select an agent');
                                                        return Promise.reject();
                                                    }

                                                    try {
                                                        // Show loading
                                                        message.loading({
                                                            content: 'Transferring lead...',
                                                            key: 'transferLead'
                                                        });

                                                        // Update lead with new agent
                                                        const updateResponse = await API.UpdateLead(id, {
                                                            handledBy: selectedAgent._id,
                                                            perviousAgent: lead.handledBy,
                                                            //   perviousAgentName: agentName,
                                                            secondaryStatus: 'No' // Reset secondary status
                                                        });

                                                        if (updateResponse?.status) {
                                                            message.success({
                                                                content: `Lead transferred to ${selectedAgent.firstName} ${selectedAgent.lastName}`,
                                                                key: 'transferLead',
                                                                icon: <CheckCircleFilled style={{ color: '#52c41a' }} />
                                                            });

                                                            // Refresh lead data
                                                            const leadResponse = await API.GetLeadById(id);
                                                            if (leadResponse?.status) {
                                                                setLead(leadResponse.data);
                                                            }
                                                        } else {
                                                            message.error({
                                                                content: updateResponse?.message || 'Failed to transfer lead',
                                                                key: 'transferLead'
                                                            });
                                                        }
                                                    } catch (error) {
                                                        console.error('Transfer error:', error);
                                                        message.error({
                                                            content: 'Failed to transfer lead',
                                                            key: 'transferLead'
                                                        });
                                                    }
                                                    resolve();
                                                },
                                                onCancel: () => resolve(),
                                                okText: 'Transfer',
                                                cancelText: 'Cancel'
                                            });
                                        });
                                    },
                                    okText: 'Continue',
                                    cancelText: 'Cancel'
                                });
                            }}
                        >
                            Transfer Lead
                        </Button>
                    </Tooltip>

                    {/* Add these styles to your CSS file */}
                    <style jsx>{`
    .transfer-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 36px;
      border-radius: 4px;
      transition: all 0.3s;
    }
    
    .transfer-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
    
    .modal-icon {
      font-size: 20px;
      color: #1890ff;
    }
    
    .transfer-type-selection p,
    .agent-selection p {
      font-size: 15px;
      margin-bottom: 8px;
      color: #333;
    }
    
    .option-label {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    /* Add these to your global CSS */
    .transfer-modal .ant-modal-content,
    .agent-select-modal .ant-modal-content {
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    .transfer-modal .ant-modal-header,
    .agent-select-modal .ant-modal-header {
      border-radius: 8px 8px 0 0;
      padding: 16px 24px;
      background: #f8f9fa;
    }
    
    .transfer-modal .ant-modal-title,
    .agent-select-modal .ant-modal-title {
      font-size: 18px;
      font-weight: 600;
    }
    
    .transfer-modal .ant-modal-body,
    .agent-select-modal .ant-modal-body {
      padding: 24px;
    }
    
    .transfer-modal .ant-modal-footer,
    .agent-select-modal .ant-modal-footer {
      border-radius: 0 0 8px 8px;
      padding: 16px 24px;
    }
  `}</style>
                </div>
            </div>

            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <Card style={{ borderRadius: '8px' }}>
                        <Row gutter={24} align="middle">
                            <Col lg={18} md={16} sm={24}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CarOutlined style={{ fontSize: '28px', marginRight: '12px', color: '#1890ff' }} />
                                    <div>
                                        <Title level={3} style={{ margin: 0 }}>
                                            {lead.vehicleInfo.year} {lead.vehicleInfo.make} {lead.vehicleInfo.model} - {lead.vehicleInfo.part}
                                        </Title>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '8px' }}>
                                            <Tag color={stageStyle.color}>{lead.leadStage}</Tag>
                                            <Text type="secondary">
                                                <InfoCircleOutlined /> ID: {lead._id.substring(0, 8)}...
                                            </Text>
                                            <Text type="secondary">
                                                <ClockCircleOutlined /> Created: {moment(lead.createdAt).format('MM-DD-YYYY')}
                                            </Text>
                                            {lead.domain && (
                                                <Text type="secondary">
                                                    <MailOutlined /> {lead.domain}
                                                </Text>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} md={8} sm={24} style={{ textAlign: 'right' }}>
                                <Button
                                    type="primary"
                                    icon={<MailOutlined />}
                                    onClick={() => setIsEmailModalVisible(true)}
                                    style={{ marginRight: '8px' }}
                                    disabled={!lead.personalInfo?.email}
                                >
                                    Send Email
                                </Button>
                                <Button
                                    icon={<PhoneOutlined />}
                                    href={`tel:${lead.personalInfo?.phoneNumber}`}
                                    disabled={!lead.personalInfo?.phoneNumber}

                                >
                                    Call
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col lg={16} md={24}>
                    <Card
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <InfoCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>Lead Details</span>
                            </div>
                        }
                        style={{ borderRadius: '8px' }}
                    >
                        <Row gutter={[24, 24]}>
                            <Col md={12} sm={24}>
                                <div className="info-section">
                                    <Title level={4} style={{
                                        borderBottom: '2px solid #1890ff',
                                        paddingBottom: '8px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <CarOutlined style={{ marginRight: '8px' }} /> Vehicle Information
                                    </Title>
                                    <Row gutter={[0, 8]} style={{ fontSize: '16px' }}>
                                        <Col span={24}><Text strong>Make:</Text> {lead.vehicleInfo.make || 'N/A'}</Col>
                                        <Col span={24}><Text strong>Model:</Text> {lead.vehicleInfo.model || 'N/A'}</Col>
                                        <Col span={24}><Text strong>Year:</Text> {lead.vehicleInfo.year || 'N/A'}</Col>
                                        <Col span={24}><Text strong>Part:</Text> {lead.vehicleInfo.part || 'N/A'}</Col>
                                        <Col span={24}><Text strong>VIN Number:</Text> {lead.vehicleInfo.vin || 'N/A'}</Col>

                                    </Row>
                                </div>
                            </Col>

                            <Col md={12} sm={24}>
                                <div className="info-section">
                                    <Title level={4} style={{
                                        borderBottom: '2px solid #1890ff',
                                        paddingBottom: '8px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <ShoppingOutlined style={{ marginRight: '8px' }} /> Lead Information
                                    </Title>
                                    <div style={{ fontSize: '15px', lineHeight: '1.8' }}>
                                        <Row gutter={[0, 8]}>

                                            <Col span={24}>
                                                <Text strong>Follow-up Date:</Text> {lead.followUpDate ? moment(lead.followUpDate).format('MM-DD-YYYY h:mm A') : 'N/A'}
                                            </Col>
                                            <Col span={24}>
                                                <Text strong>Current Stage:</Text>
                                                <Tag color={stageStyle.color} style={{ marginLeft: '8px' }}>
                                                    {lead.leadStage}
                                                </Tag>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Divider style={{ margin: '16px 0' }} />

                        <Title level={4} style={{
                            borderBottom: '2px solid #1890ff',
                            paddingBottom: '8px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <UserOutlined style={{ marginRight: '8px' }} /> Personal Information
                        </Title>
                        <div style={{ fontSize: '15px', lineHeight: '1.8' }}>
                            <Row gutter={[0, 12]}>
                                <Col span={24}>
                                    <Row gutter={[16, 8]}>
                                        <Col md={12} sm={24}>
                                            <Text strong>Full Name:</Text> <span>{lead.personalInfo.fullName || 'N/A'}</span>
                                        </Col>
                                        <Col md={12} sm={24}>
                                            <Text strong>Email:</Text> <span>{lead.personalInfo.email || 'N/A'}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Row gutter={[16, 8]}>
                                        <Col md={12} sm={24}>
                                            <Text strong>Phone Number:</Text> <span>{lead.personalInfo.phoneNumber || 'N/A'}</span>
                                        </Col>
                                        <Col md={12} sm={24}>
                                            <Text strong>Zip Code:</Text> <span>{lead.personalInfo.zipCode || 'N/A'}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>

                        <Divider style={{ margin: '16px 0' }} />
                        {lead.quotedValue.length > 0 && (
                            <>
                                <Title level={4} style={{
                                    borderBottom: '2px solid #1890ff',
                                    paddingBottom: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <span>
                                        <DollarOutlined style={{ marginRight: '8px' }} /> Price Quote
                                    </span>
                                    {lead.quotedValue.length < 3 && !newQuotePrice && (
                                        <Button
                                            type="primary"
                                            size="small"
                                            onClick={() => setNewQuotePrice('')}
                                        >
                                            Add Quote
                                        </Button>
                                    )}
                                </Title>

                                {newQuotePrice !== null && (
                                    <div style={{ marginTop: '16px', textAlign: 'center' }}>
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                gap: '12px',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <InputNumber
                                                style={{ width: 180 }}
                                                value={newQuotePrice}
                                                onChange={setNewQuotePrice}
                                                placeholder="Enter new quote amount"
                                                min={0}
                                                formatter={(value) => `$ ${value}`}
                                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            />
                                            <Button
                                                type="primary"
                                                onClick={() => handleUpdateQuote(newQuotePrice)}
                                                disabled={!newQuotePrice}
                                            >
                                                Submit
                                            </Button>
                                            <Button onClick={() => setNewQuotePrice(null)}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>

                                )}

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '16px' }}>
                                    {lead.quotedValue?.map((quote, index) => (
                                        <Card
                                            key={quote._id || index}
                                            style={{
                                                flexGrow: 1,
                                                flexBasis: 'calc(50% - 8px)',
                                                textAlign: 'center',
                                                background: 'linear-gradient(135deg, #f6f8fa 0%, #f0f2f5 100%)',
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                borderTop: '3px solid #1890ff'
                                            }}
                                        >
                                            <Statistic
                                                title="Quote Amount"
                                                value={quote.price}
                                                prefix="$"
                                                valueStyle={{ color: '#1890ff', fontWeight: 'bold' }}
                                            />
                                            <Text type="secondary">
                                                Quoted on {moment(quote.addedAt).format('MM-DD-YYYY')}
                                            </Text>
                                            {index === lead.quotedValue.length - 1 && (
                                                <Tag color="blue" style={{ marginTop: '8px' }}>Latest</Tag>
                                            )}
                                        </Card>
                                    ))}
                                </div>
                            </>
                        )}


                    </Card>
                    {lead?.leadStage === "Sales Made" ? (
                        <Card
                            style={{
                                marginTop: 24,
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)',
                                padding: 0,
                                overflow: "hidden"
                            }}
                        >
                            {/* Order Confirmation Section */}
                            <div
                                style={{
                                    background: "linear-gradient(to right, #4A90E2, #2962FF)",
                                    padding: "24px",
                                    color: "white",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px"
                                }}
                            >
                                <Tag color="blue" style={{ fontSize: "14px", padding: "5px 12px", borderRadius: "16px" }}>
                                    <CheckCircleOutlined /> Order Confirmed
                                </Tag>

                                <Title level={3} style={{ color: "white", marginTop: 8 }}>
                                    {lead.orderNumber}
                                </Title>

                                <Text style={{ fontSize: "14px", opacity: 0.9 }}>
                                    <CalendarOutlined style={{ marginRight: 8 }} />
                                    Placed on {formatDateToPST(lead.orderDate)}
                                </Text>
                            </div>
                            {/* Business Name Section (Single Line) */}
                            <Row gutter={16} style={{ padding: "24px" }}>
                                <Col span={24}>
                                    <Card
                                        style={{
                                            background: "#f9fafb",
                                            borderRadius: "8px",
                                            border: "1px solid #e0e0e0",
                                            padding: "12px",
                                        }}
                                    >
                                        <Text strong style={{ fontSize: "16px", display: "flex", alignItems: "center" }}>
                                            <BankOutlined style={{ color: "#1890ff", marginRight: 8 }} />
                                            Business Name:&nbsp;
                                            <span style={{ color: "#000000" }}>
                                                {lead.bussinessName}
                                            </span>
                                        </Text>
                                    </Card>
                                </Col>
                            </Row>


                            {/* Address Section */}
                            <Row gutter={16} style={{ padding: "24px" }}>
                                {/* Shipping Address */}
                                <Col xs={24} md={12}>
                                    <Card
                                        style={{
                                            background: "#f9fafb",
                                            borderRadius: "8px",
                                            border: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Text strong style={{ fontSize: "16px" }}>
                                            <EnvironmentOutlined style={{ color: "#1890ff", marginRight: 8 }} />
                                            Shipping Address
                                        </Text>
                                        <p style={{ margin: "8px 0" }}>
                                            {lead.shippingAddress.street},<br />
                                            {lead.shippingAddress.city}, {lead.shippingAddress.state},<br />
                                            {lead.shippingAddress.zip}
                                        </p>

                                    </Card>
                                </Col>

                                {/* Billing Address */}
                                <Col xs={24} md={12}>
                                    <Card
                                        style={{
                                            background: "#f9fafb",
                                            borderRadius: "8px",
                                            border: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Text strong style={{ fontSize: "16px" }}>
                                            <CreditCardOutlined style={{ color: "#1890ff", marginRight: 8 }} />
                                            Billing Address
                                        </Text>
                                        <p style={{ margin: "8px 0" }}>
                                            {lead.billingAddress.street},<br />
                                            {lead.billingAddress.city}, {lead.billingAddress.state},<br />
                                            {lead.billingAddress.zip}
                                        </p>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    ) : null}

                    {lead.quotes.length > 0 && !["Payment Completed", "Sales Made"].includes(lead.leadStage) && (
                        <Card
                            title={
                                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                    <DollarOutlined style={{ color: '#6495ED', marginRight: 8 }} />
                                    Pending Payment Details
                                </span>
                            }
                            style={{
                                marginTop: 24,
                                borderRadius: '12px',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.12)',
                                padding: '16px',
                            }}
                        >
                            {/* Total Amount */}
                            <Typography.Title level={2} style={{ margin: 0 }}>
                                ${totalPrice.toFixed(2)}
                            </Typography.Title>

                            <hr style={{ margin: '12px 0', border: '1px solid #eee' }} />

                            {/* Invoice Number & Payment Status */}
                            {/* <div style={{ fontSize: '16px', marginBottom: 8 }}>
                                       <strong>Invoice Number:</strong> <span>#INV-2023-0458</span>
                                   </div> */}
                            <div style={{ fontSize: '16px', marginBottom: 8 }}>
                                <strong>Payment Status:</strong>{' '}
                                <span style={{ color: 'orange', fontWeight: 600 }}>{lead.paymentStatus}</span>
                            </div>

                            {/* Advance Payment */}
                            <div style={{ fontSize: '16px', marginBottom: 8 }}>
                                <strong>Advance Payment:</strong> ${advancePrice.toFixed(2)}
                            </div>

                            {/* Balance Payment */}
                            <div
                                style={{
                                    background: '#f0fdf4',
                                    padding: '12px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#22c55e',
                                    borderRadius: '6px',
                                    marginTop: 12,
                                }}
                            >
                                Balance Payment: ${balancePrice.toFixed(2)}
                            </div>
                            <div style={{ marginTop: 16, display: 'flex', gap: '12px' }}>

                                <Button
                                    type="primary"
                                    style={{ background: '#4169E1', borderColor: '#4169E1' }}
                                    onClick={() => setPaymentModalVisible(true)}
                                    disabled={getRemainingBalance() === 0} // Disable when total is 0

                                >
                                    Pay Balance
                                </Button>
                            </div>


                        </Card>
                    )}

                    {["Payment Completed", "Sales Made"].includes(lead.leadStage) && (
                        <Card
                            style={{
                                marginTop: 24,
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                padding: 0,
                                overflow: 'hidden',
                                border: '1px solid #e5e7eb',
                            }}
                        >
                            {/* Green Header Section */}
                            <div
                                style={{
                                    background: '#22c55e',
                                    padding: '24px',
                                    color: '#fff',
                                    textAlign: 'left',
                                }}
                            >

                                <Typography.Title level={3} style={{ marginTop: 8, marginBottom: 4, color: '#fff' }}>
                                    Payment Completed
                                </Typography.Title>
                                <Typography.Title level={2} style={{ margin: 0, color: '#fff' }}>
                                    ${lead?.quotes[0]?.amount?.toFixed(2)}
                                </Typography.Title>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                                    <CheckCircleOutlined style={{ fontSize: 16 }} />
                                    <Typography.Text style={{ fontSize: 16, fontWeight: 500, color: '#fff' }}>
                                        Fully Paid
                                    </Typography.Text>
                                </div>
                            </div>

                            {/* Payment Info Section */}
                            <div style={{ padding: '20px' }}>
                                <Typography.Title level={5} style={{ marginBottom: 12 }}>
                                    Payment Information
                                </Typography.Title>

                                {lead.advancePayments.length > 0 && (() => {
                                    const lastPayment = lead.advancePayments[lead.advancePayments.length - 1];

                                    return (
                                        <div style={{ fontSize: '15px', color: '#374151' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <strong>Payment Method:</strong> <span>{lastPayment.paymentMethod}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
                                                <strong>Payment Status:</strong> <span>{lastPayment.status}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
                                                <strong>Transaction ID:</strong> <span>{lastPayment.id}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
                                                <strong>Date:</strong> <span>{new Date(lastPayment.date).toLocaleString()}</span>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>

                            {/* Buttons */}
                            <div
                                style={{
                                    display: 'flex',
                                    gap: 10,
                                    padding: '16px',
                                    background: '#f9fafb',
                                    borderTop: '1px solid #e5e7eb',
                                }}
                            >
                                <Button
                                    type="primary"
                                    style={{
                                        background: '#16a34a',
                                        borderColor: '#16a34a',
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 6,
                                        height: 40,
                                    }}
                                    onClick={() => setPaymentHistoryModalVisible(true)}
                                >
                                    <SendOutlined />
                                    Payment History
                                </Button>
                                <Button
                                    type="default"
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 6,
                                        height: 40,
                                        borderColor: '#16a34a',
                                        color: '#16a34a',
                                    }}
                                    onClick={generatePaymentPDF}
                                >
                                    <DownloadOutlined />
                                    Download Receipt
                                </Button>
                            </div>
                        </Card>

                    )}
                    <Card
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <MessageOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>Communication History</span>
                            </div>
                        }
                        bordered={false}
                        style={{ marginTop: '24px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    >
                        {stageHistory.filter(item => item.comment).map((item, index) => (
                            <div key={index} style={{
                                marginBottom: '16px',
                                padding: '16px',
                                background: leadStageColors[item.stage]?.background || '#f9f9f9',
                                borderRadius: '8px',
                                border: `1px solid ${leadStageColors[item.stage]?.color || '#d9d9d9'}`,
                                position: 'relative'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '-12px',
                                    left: '16px',
                                    background: leadStageColors[item.stage]?.color || '#d9d9d9',
                                    color: 'white',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '12px'
                                }}>
                                    {item.stage} Comment
                                </div>
                                <div style={{ marginTop: '8px', fontSize: '14px', lineHeight: '1.6' }}>
                                    {item.comment}
                                </div>
                                <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>
                                    <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                    {moment(item.date).format('MM-DD-YYYY h:mm A')}
                                </div>
                            </div>
                        ))}

                        <div className="comments-container">
                            {leadComments.length > 0 ? leadComments.map(comment => (
                                <CommentItem key={comment._id} comment={comment} />
                            )) : (
                                <div style={{ textAlign: 'center', padding: '24px 0' }}>
                                    <MessageOutlined style={{ fontSize: '24px', color: '#bfbfbf' }} />
                                    <Paragraph style={{ marginTop: '8px', color: '#8c8c8c' }}>
                                        No additional comments yet.
                                    </Paragraph>
                                </div>
                            )}
                        </div>

                        <div style={{ marginTop: '24px' }}>
                            <Title level={5} style={{ display: 'flex', alignItems: 'center' }}>
                                <SendOutlined style={{ marginRight: '8px' }} /> Add Comment
                            </Title>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '8px', overflow: 'hidden' }}>
                                <ReactQuill
                                    value={commentText}
                                    onChange={setCommentText}
                                    modules={modules}
                                    formats={formats}
                                    placeholder="Add your comment..."
                                    style={{ height: '150px', marginBottom: '40px', borderRadius: '8px' }}
                                />
                            </div>
                            <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    type="primary"
                                    icon={<SendOutlined />}
                                    onClick={handleCommentSubmit}
                                    disabled={!commentText.trim() || isSubmitting}
                                    loading={isSubmitting}
                                    size="large"
                                >
                                    Post Comment
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Col>

                <Col lg={8} md={24}>
                    <LeadStageCard
                        leadStage={stage}
                        leadStages={leadStages}
                        stageColorMap={leadStageColors}
                        handleStageChange={handleStageChange}
                    />

                    <Card
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <ClockCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>Lead Stage History</span>
                            </div>
                        }
                        style={{ borderRadius: '8px', marginTop: '24px' }}
                    >
                        {stageHistory.length > 0 ? (
                            <Timeline mode="left" style={{ marginTop: '16px' }}>
                                {stageHistory.map((item, index) => {
                                    const stageStyle = leadStageColors[item.stage] || { color: '#000', background: '#fff' };
                                    return (
                                        <Timeline.Item
                                            key={index}
                                            color={stageStyle.color}
                                            label={moment(item.date).format('MM-DD-YYYY h:mm A')}
                                        >
                                            <div style={{
                                                padding: '12px',
                                                borderRadius: '8px',
                                                color: stageStyle.color,
                                                backgroundColor: stageStyle.background,
                                                fontWeight: 'bold'
                                            }}>
                                                {item.stage}
                                            </div>
                                        </Timeline.Item>
                                    );
                                })}
                            </Timeline>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '24px 0' }}>
                                <InfoCircleOutlined style={{ fontSize: '24px', color: '#bfbfbf' }} />
                                <Paragraph style={{ marginTop: '8px', color: '#8c8c8c' }}>
                                    No stage history available.
                                </Paragraph>
                            </div>
                        )}
                    </Card>

                    <Card
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <InfoCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>Quick Actions</span>
                            </div>
                        }
                        style={{ borderRadius: '8px', marginTop: '24px' }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <Button
                                type="primary"
                                icon={<MailOutlined />}
                                block
                                size="large"
                                onClick={() => setIsEmailModalVisible(true)}
                                disabled={!lead.personalInfo?.email}
                            >
                                Send Email
                            </Button>
                            <Button
                                type="default"
                                icon={<PhoneOutlined />}
                                block
                                size="large"
                                href={`tel:${lead.personalInfo?.phoneNumber}`}
                                disabled={!lead.personalInfo?.phoneNumber}
                            >
                                Call Customer
                            </Button>
                        </div>
                    </Card>

                    <Card
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <UserOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>Customer Summary</span>
                            </div>
                        }
                        style={{ borderRadius: '8px', marginTop: '24px' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <Avatar
                                name={lead.personalInfo?.fullName || 'Unknown'}
                                size="64"
                                round={true}
                                color="#1890ff"
                                textSizeRatio={2}
                            />
                            <div style={{ marginLeft: '16px' }}>
                                <Title level={5} style={{ margin: 0 }}>
                                    {lead.personalInfo?.fullName || 'Unknown Customer'}
                                </Title>
                                <Text type="secondary" style={{ fontSize: '14px' }}>
                                    {lead.personalInfo?.email || 'N/A'}
                                </Text>
                                <Text type="secondary" style={{ fontSize: '14px' }}>
                                    {lead.personalInfo?.phoneNumber || 'N/A'}
                                </Text>
                            </div>
                        </div>

                        <Divider style={{ margin: '16px 0' }} />

                        <Title level={5} style={{ marginBottom: '16px' }}>
                            <InfoCircleOutlined style={{ marginRight: '8px' }} /> Customer Details
                        </Title>
                        <div style={{ fontSize: '15px', lineHeight: '1.8' }}>
                            <Row gutter={[0, 12]}>
                                <Col span={24}>
                                    <Text strong>Customer Type:</Text> {lead.isExistingCustomer ? 'Existing Customer' : 'New Customer'}
                                </Col>
                                <Col span={24}>
                                    <Text strong>Lead Type:</Text> {lead.leadType === 'outbound' ? 'Outbound Lead' : 'Inbound Lead'}
                                </Col>

                            </Row>
                        </div>
                    </Card>

                    {lead?.secondaryStatus === 'No' && (

                        <Card
                            title={<span><UserOutlined /> Assigned Agent</span>}
                            style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar size={64} icon={<UserOutlined />} />
                                <div style={{ marginLeft: 16 }}>
                                    <Text strong>{lead?.currentAgentName}</Text>
                                    <br />
                                    <Text type="secondary">{lead?.handledBy}</Text>
                                </div>
                            </div>
                        </Card>
                    )}

                    {lead?.secondaryStatus === 'Yes' && (
                        <Card
                            title={<span><TeamOutlined /> Agent History</span>}
                            style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)' }}
                        >
                            <Descriptions column={1}>
                                <Descriptions.Item label="Previous Agent">
                                    <div>
                                        <div style={{ marginBottom: 8 }}>
                                            <Avatar size="small" icon={<UserOutlined />} style={{ marginRight: 8 }} />
                                            <Text strong>{lead.perviousAgentName || 'Not assigned'}</Text>
                                        </div>

                                        <Text type="secondary">{lead?.perviousAgent}</Text>
                                    </div>
                                </Descriptions.Item>
                                <Descriptions.Item label="Current Agent">
                                    <div>
                                        <div style={{ marginBottom: 8 }}>
                                            <Avatar size="small" icon={<UserOutlined />} style={{ marginRight: 8 }} />
                                            <Text strong>{lead?.currentAgentName}</Text>
                                        </div>
                                        <Text type="secondary">{lead?.handledBy}</Text>
                                    </div>
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    )}
                </Col>
            </Row>
            <Modal
                visible={paymentModalVisible}
                title="Pay Balance"
                maskClosable={false}
                closable={false}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setPaymentModalVisible(false);
                            setPaymentForm({
                                amount: '',
                                paymentMethod: 'Credit Card',
                                description: ''
                            });
                            setPaymentFormErrors({ amount: '' });
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleRecordPayment}
                        disabled={!paymentForm.amount || paymentFormErrors.amount}
                    >
                        Record Payment
                    </Button>
                ]}
            >
                <FormItem
                    label="Amount"
                    error={paymentFormErrors.amount}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        value={paymentForm.amount}
                        onChange={handlePaymentAmountChange}
                        placeholder="Enter payment amount"
                        min={0}
                        max={getQuoteTotal() - getAdvancePaymentTotal()}
                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                        status={paymentFormErrors.amount ? 'error' : ''}
                    />
                    <div style={{ marginTop: 8, color: '#888' }}>
                        Remaining balance: ${(getQuoteTotal() - getAdvancePaymentTotal()).toFixed(2)}
                    </div>
                </FormItem>
                <FormItem label="Payment Method">
                    <Select
                        value={paymentForm.paymentMethod}
                        onChange={handlePaymentFormChange('paymentMethod')}
                        options={[
                            { value: 'Credit Card', label: 'Credit Card' },
                            { value: 'Bank Transfer', label: 'Bank Transfer' },
                            { value: 'Cash', label: 'Cash' },
                            { value: 'Check', label: 'Check' },
                            { value: 'Other', label: 'Other' }
                        ]}
                    />
                </FormItem>
                <FormItem label="Description">
                    <Input.TextArea
                        value={paymentForm.description}
                        onChange={handlePaymentFormChange('description')}
                        placeholder="Enter payment description"
                    />
                </FormItem>
                {/* Rest of the form fields */}
            </Modal>
            <EmailTemplateModal
                visible={isEmailModalVisible}
                onCancel={() => setIsEmailModalVisible(false)}
                onSend={handleSendEmail}
                lead={lead}
                userData={userData}
            />
            <PaymentHistoryModal
                visible={paymentHistoryModalVisible}
                onCancel={() => setPaymentHistoryModalVisible(false)}
                payments={lead?.advancePayments || []}
                quotes={lead?.quotes || []}
            />
        </div>
    );
};

export default IndividualFollowUpLead;